module.exports = __webpack_public_path__ + "media/svg/view-dashboard-outline-00dbab7d.svg";